// extracted by css-extract-rspack-plugin
export default {"PermissionsEditorRoot":"QqDX9"};